
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"264","height":"268","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d)","fill":"#1F213E"}},[_c('path',{attrs:{"d":"M240.446 227.382a1.297 1.297 0 00-2.224.53l-2.128 8.089c-11.754-4.543-30.21-15.898-33.89-42.411l-.533-3.843a1.297 1.297 0 00-1.459-1.103l-12.808 1.778c-.706.1-1.199.752-1.103 1.459l.533 3.842a65.829 65.829 0 0021.335 40.838 73.403 73.403 0 0023.957 14.587l-1.872 7.113a1.284 1.284 0 001.663 1.545l26.755-9.183a1.303 1.303 0 00.546-2.087l-18.772-21.154z"}}),_c('path',{attrs:{"d":"M255 125.5c0 69.312-56.188 125.5-125.5 125.5S4 194.812 4 125.5 60.188 0 129.5 0 255 56.188 255 125.5z"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":"0","y":"0","width":"263.54","height":"267.879","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    